import React from 'react'
import { useLocation } from 'react-router-dom'
import { node } from 'prop-types'

/**
 * Notice:
 * provides the currentUri prop
 * this will required when the user triggers the aok localisation context
 * after localisation the typo instanz will load the last ressource from this property
 *
 * @param children
 * @returns {JSX.Element}
 * @constructor
 */
const WindowCurrentUriSetter = ({ children }) => {
  const { search } = useLocation()

  React.useEffect(() => {
    window.currentUri = window.location + search
  }, [search])

  return <>{children}</>
}

WindowCurrentUriSetter.propTypes = {
  children: node.isRequired,
}

export default WindowCurrentUriSetter
